<template>
  <div class="chat-bubble" @mousedown.stop @contextmenu.prevent>
      <dropdown trigger="" ref="dropdown" size="mini" v-if="!message.isRevoked" @command="handleCommand">
        <div class="message-content" :class="bubbleStyle">
            <slot></slot>
        </div>
        <dropdown-menu slot="dropdown">
            <dropdown-item command="revoke" v-if="isMine&&!this.isTimeout">撤回</dropdown-item>
            <dropdown-item command="delete">删除</dropdown-item>
        </dropdown-menu>
      </dropdown>

    <div class="group-tip-element-wrapper text-center" v-if="message.isRevoked">
      {{text}}
      <a class="text-primary" v-show="isEdit" @click="reEdit">&nbsp;重新编辑</a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Dropdown, DropdownMenu, DropdownItem } from "element-ui";

export default {
  name: 'MessageBubble',
  data() {
    return {
      isTimeout: false,
      adminRecall:false
    }
  },
  components: {
      Dropdown, DropdownMenu, DropdownItem
  },
  props: {
    isMine: {
      type: Boolean
    },
    isNew: {
      type: Boolean
    },
    message: {
      type: Object,
      required: true
    }
  },
  created() {
    this.isTimeoutHandler()
  },
  mounted() {
    if (this.$refs.dropdown && this.$refs.dropdown.$el) {
      this.$refs.dropdown.$el.addEventListener('mousedown', this.handleDropDownMousedown)
    }
  },
  beforeDestroy() {
    if (this.$refs.dropdown && this.$refs.dropdown.$el) {
      this.$refs.dropdown.$el.removeEventListener('mousedown', this.handleDropDownMousedown)
    }
  },
  computed: {
    ...mapState({
      currentConversation: state => state.conversation.currentConversation,
    }),
    bubbleStyle() {
      let classString = ''
      if (this.isMine) {
        classString += 'message-send'
      } else {
        classString += 'message-received'
      }
      if (this.isNew) {
        classString += 'new'
      }
      return classString
    },
    isAdmin() {
      return this.currentConversation.groupProfile.selfInfo.role === 'Admin'
    },
    text() {
        if(this.adminRecall){
            return `管理员撤回了一条消息`
        }
      if (this.message.conversationType === 'C2C' && !this.isMine) {
        return '对方撤回了一条消息'
      }
      if (this.message.conversationType === 'GROUP' && !this.isMine) {
        return `${this.message.nick || this.message.from}撤回了一条消息`
      }
      return '你撤回了一条消息'
    },
    isEdit() {
      if (!this.isMine) {
        return false
      }
      if (this.message.type !== this.TIM.TYPES.MSG_TEXT) {
        return false
      }
      if (this.isTimeout) {
        return false
      }
      return true
    },
  },
  methods: {
    deleteMessage(){
        axios.post('/lectures/recallmessage',{'group_id' :this.message.to,'msg_seq':this.message.sequence}).then(resp => {
            if(resp.data.ActionStatus == 'OK'){
                this.adminRecall = true;
            }
        })
    },
    handleDropDownMousedown(e) {
    // if (!this.isMine||this.isTimeout) {
    //     return
    //   }
      if (e.buttons === 2) {
        if (this.$refs.dropdown.visible) {
          this.$refs.dropdown.hide()
        } else {
          this.$refs.dropdown.show()
        }
      }
    },
    handleCommand(command) {
      switch (command) {
        case 'revoke':
          this.tim.revokeMessage(this.message).then(() => {
            this.isTimeoutHandler()
          }).catch((err) => {
            this.$store.commit('showMessage', {
              message: err,
              type: 'warning'
            })
          })
          break
        case 'delete':
            this.deleteMessage();
          break
        default:
          break
      }
    },
    isTimeoutHandler() { // 从发送消息时间开始算起，两分钟内可以编辑
      let now = new Date()
      if (parseInt(now.getTime() / 1000) - this.message.time > 2 * 60) {
        this.isTimeout = true
        return
      }
      setTimeout(this.isTimeoutHandler, 1000)
    },
    reEdit() {
      this.$bus.$emit('reEditMessage', this.message.payload.text)
    }
  }
}
</script>
